import { createSelector } from 'reselect';

import { getState as getParent, getRoot, getById } from 'modules/questionModels/selectors';

const getState = createSelector(getParent, state => state.ui.details);

export const getSelectedId = createSelector(getState, state => state.selectedId);
export const getSelectedQuestionModel = createSelector(getRoot, getSelectedId, getById);

export const isReady = createSelector(getState, state => state.isReady);
export const isLoading = createSelector(getState, state => state.isLoading);
export const hasError = createSelector(getState, state => state.apiError);
export const isUpdating = createSelector(getState, state => state.isUpdating);

export const getSelectedLocale = createSelector(getState, state => state.selectedLocale);
